import { createContext, useContext } from 'react';

export type SearchGridHelpContextValue = {
  openSearchHelp: (sectionId?: string) => void;
};

export const SearchGridHelpContext = createContext<SearchGridHelpContextValue | null>(null);

export function useSearchGridHelp() {
  return useContext(SearchGridHelpContext);
}
